<div class="app-container">
  <router-outlet></router-outlet>
</div>

<div *ngIf="loading" class="spinner">
  <mat-spinner diameter="60" strokeWidth="6" color="primary"></mat-spinner>
</div>
